import { getApi } from "../api";

export const getAllBusinessApi = () => getApi(`/user/subscription-business/2`);
// export const getAllBusinessApi = () => getApi(`/user/list-business`);
